import { render, staticRenderFns } from "./button-base.vue?vue&type=template&id=06a44525&scoped=true&"
import script from "./button-base.vue?vue&type=script&lang=ts&"
export * from "./button-base.vue?vue&type=script&lang=ts&"
import style0 from "./button-base.vue?vue&type=style&index=0&id=06a44525&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a44525",
  null
  
)

export default component.exports